import { setSessionStorageItem } from '../../sessionStorage/utils';
import { SESSION_STORAGE_LAST_SELECTED_RETURN_FLIGHT } from '../../../utils/constants';

export default (selectedReturnVar) => {
  return (newSelectedReturn) => {
    selectedReturnVar(newSelectedReturn);
    setSessionStorageItem(SESSION_STORAGE_LAST_SELECTED_RETURN_FLIGHT, newSelectedReturn);
  };
};
